import React from 'react';

export interface SaveRecordProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  width?: number;
  height?: number;
}

export const SaveRecord: React.FC<SaveRecordProps> = ({ size = 14, width, height, ...props }) => {
  const w = width ?? size;
  const h = height ?? size;

  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.5 13.5C1.0875 13.5 0.73125 13.3563 0.43125 13.0688C0.14375 12.7688 0 12.4125 0 12V1.5C0 1.0875 0.14375 0.737501 0.43125 0.450001C0.73125 0.15 1.0875 0 1.5 0H12C12.4125 0 12.7625 0.15 13.05 0.450001C13.35 0.737501 13.5 1.0875 13.5 1.5V12C13.5 12.4125 13.35 12.7688 13.05 13.0688C12.7625 13.3563 12.4125 13.5 12 13.5H1.5ZM6.75 9.75C7.225 9.75 7.65625 9.6125 8.04375 9.3375C8.43125 9.0625 8.7 8.7 8.85 8.25H12V1.5H1.5V8.25H4.65C4.8 8.7 5.06875 9.0625 5.45625 9.3375C5.84375 9.6125 6.275 9.75 6.75 9.75Z"
        fill="currentColor"
      />
    </svg>
  );
};
